// src/data/advantages.js
import React from 'react';
import { Shield, Award, Factory, Clock } from 'lucide-react';

/**
 * @typedef {object} AdvantageItem
 * @property {React.ReactElement} icon - The Lucide React icon component for the advantage.
 * @property {string} title - The title of the advantage.
 * @property {string} description - A detailed description of the advantage.
 */

/**
 * An array of advantage items for the application.
 * @type {AdvantageItem[]}
 */
const advantages = [
  {
    icon: <Factory className="w-8 h-8" />,
    title: 'Прямой производитель',
    description:
      'Работа без посредников: полный контроль качества, гибкие цены и оперативное изготовление.',
  },
  {
    icon: <Shield className="w-8 h-8" />,
    title: 'Гарантия безопасности',
    description:
      'Семикратный запас прочности (7:1) и соответствие международным стандартам для вашей уверенности.',
  },
  {
    icon: <Award className="w-8 h-8" />,
    title: 'Казахстанское производство',
    description:
      'Сертификат СТ-KZ подтверждает происхождение товара и упрощает ваше участие в закупках.',
  },
  {
    icon: <Clock className="w-8 h-8" />,
    title: 'Оперативность',
    description: 'Быстрая доставка по Казахстану и консультации от экспертов производства.',
  },
];

export default advantages;
